<template>
<ValidationObserver v-if="orderId" class="order-submission-form" tag="form" @submit.prevent ref="validationObserver">
  <section v-if="!orderCustomer" class="form-card name-and-phone">
    <div class="fields-container">
      <!-- `vee-validate` doesn't recognize initial value, so have to copy-paste `:disabled` for the provider. -->
      <ValidationProvider rules="required" name="телефон" :custom-messages="{ required: 'Необходимо указать номер телефона' }" slim>
        <!-- TODO remove validation error as soon as a valid number was input, not just on blur. -->
        <template slot-scope="{ errors, validate }">
          <CustomField label="Телефон *" class="form-field" :error="errors[0]">
            <PhoneInput v-model="form.phone"
                        slot-scope="{ id }"
                        :id="id"
                        @input="validate($event)"
                        @input:country="form.phone_country = $event"
            />
          </CustomField>
        </template>
      </ValidationProvider>
      <ValidationProvider rules="required" name="имя" :custom-messages="{ required: 'Необходимо заполнить имя' }" slim>
        <template slot-scope="{ errors }">
          <CustomInput label="Имя *"
                       v-model="form.first_name"
                       @input="collapseLastNameField = false"
                       class="form-field"
                       :error="errors[0]"
                       placeholder="Введите имя"
          />
        </template>
      </ValidationProvider>
      <TransitionExpand>
        <CustomInput v-show="!collapseLastNameField"
                     label="Фамилия"
                     name="Фамилия"
                     v-model="form.last_name"
                     class="form-field"
                     placeholder="Введите фамилию"
        />
      </TransitionExpand>
    </div>
  </section>
  <section class="order-delivery-section">
    <div class="order-delivery-section__address form-card">
      <div class="order-delivery-tabbar">
        <label class="order-delivery-tab cursor-pointer" v-if="deliveryMethodAllowed" :class="{ active: form.delivery_method === 'delivery' }">
          <input type="radio" name="delivery-method" value="delivery" v-model="form.delivery_method">
          Доставка
        </label>
        <label class="order-delivery-tab cursor-pointer" v-if="pickupMethodAllowed" :class="{ active: form.delivery_method === 'pickup' }">
          <input type="radio" name="delivery-method" value="pickup" v-model="form.delivery_method">
          Самовывоз
        </label>
        <label class="order-delivery-tab cursor-pointer" v-if="onPremiseMethodAllowed" :class="{ active: form.delivery_method === 'on_premise' }">
          <input type="radio" name="delivery-method" value="on_premise" v-model="form.delivery_method">
          В заведении
        </label>
      </div>
      <div class="order-delivery__tab-content">
        <TransitionExpand>
          <div v-if="deliveryMethodAllowed && form.delivery_method === 'delivery'" key="delivery">
            <div v-if="savedAddresses.length > 0" class="order-delivery__saved-address-select form-radio-group">
              <label v-for="address in savedAddresses" :key="address.id" class="custom-radio">
                <span class="custom-radio-label">{{ addressToString(address) }}</span>
                <input type="radio"
                       name="deliveryAdress"
                       :checked="form.deliveryAddress.selectedSavedAddress && (form.deliveryAddress.selectedSavedAddress.id === address.id)"
                       @change="form.deliveryAddress.selectedSavedAddress = address"
                >
                <span class="radio-button"></span>
              </label>
              <label key="newAddress" class="custom-radio">
                <span class="custom-radio-label">Добавить новый адрес</span>
                <input type="radio"
                       name="deliveryAdress"
                       :checked="!form.deliveryAddress.selectedSavedAddress"
                       @change="form.deliveryAddress.selectedSavedAddress = null"
                >
                <span class="radio-button"></span>
              </label>
            </div>
            <TransitionExpand>
              <template v-if="!form.deliveryAddress.selectedSavedAddress">
                <dadata-address-resolver v-if="addressesResolver === 'dadata'" v-model="form.deliveryAddress.newAddress" />
                <plain-address-resolver v-else-if="addressesResolver === 'plain'" v-model="form.deliveryAddress.newAddress" />
              </template>
            </TransitionExpand>
          </div>
          <div v-else-if="pickupMethodAllowed && form.delivery_method === 'pickup'"
               class="form-radio-group form-radio-group--inline order-delivery__pickup-stocks"
               key="pickup"
          >
            <label v-for="stock in stocks" :key="stock.id" class="custom-radio">
              <span class="custom-radio-label order-submission-pickup-stock-label">
                <strong class="pickup-stock-title">{{ stock.display_name || stock.name }}</strong>
                <span v-if="stockHasAddress(stock)" class="pickup-stock-address">
                  {{ firstStockAddress(stock) }}
                </span>
                <span v-if="stockHasSchedule(stock)" class="pickup-stock-schedule">
                  {{ stockSchedule(stock) }}
                </span>
              </span>
              <input type="radio" :value="stock.id" v-model="form.stock_id">
              <span class="radio-button"></span>
            </label>
          </div>
          <div v-else-if="onPremiseMethodAllowed && form.delivery_method === 'on_premise'" key="on_premise">
            <div class="form-radio-group form-radio-group--inline order-delivery__pickup-stocks">
              <label v-for="stock in stocks" :key="stock.id" class="custom-radio">
                <span class="custom-radio-label order-submission-pickup-stock-label">
                  <strong class="pickup-stock-title">{{ stock.display_name || stock.name }}</strong>
                  <span v-if="stockHasAddress(stock)" class="pickup-stock-address">
                    {{ firstStockAddress(stock) }}
                  </span>
                  <span v-if="stockHasSchedule(stock)" class="pickup-stock-schedule">
                    {{ stockSchedule(stock) }}
                  </span>
                </span>
                <input type="radio" :value="stock.id" v-model="form.stock_id">
                <span class="radio-button"></span>
              </label>
            </div>
            <CustomField class="mb-4">
              <ValidationProvider rules="required"
                                  name="Номер стола"
                                  :custom-messages="{ required: 'Необходимо указать номер стола' }"
                                  slim
              >
                <template slot-scope="{ errors }">
                  <CustomInput class="order-delivery-table-number"
                               label="Номер стола *"
                               min="1"
                               type="number"
                               inputmode="numeric"
                               placeholder="Номер"
                               v-model="form.onPremise.table"
                               :error="errors[0]"
                  />
                </template>
              </ValidationProvider>
            </CustomField>
          </div>
        </TransitionExpand>
      </div>
    </div>
    <div class="form-card">
      <OtherInfoSection :notes.sync="form.notes"
                        :num_people.sync="form.num_people"
                        :delivery-time.sync="form.deliveryTime"
                        :deliveryTimeInputLabel="form.delivery_method === 'delivery' ? 'Время доставки' : 'Когда приготовить'"
                        class="order-delivery-section__other"
      />
    </div>
  </section>
  <cart-product-reward-card v-if="rewardSelector.available"
                            :promotion-id="rewardSelector.promotion_id"
                            :reward-id="rewardSelector.reward_id"
                            :context="rewardSelector.context"
                            :max-quantity="rewardSelector.max_quantity"
  />

  <PaymentSection v-bind.sync="form"
                  :to-pay-with-real-money-amount="$store.state.order.paymentsPreview ? $store.state.order.paymentsPreview.unpaid.value / 100 : null"
                  :hide-bonuses-section="!hasUser"
                  :max-bonuses-payment="maxBonusesPayment"
                  :bonuses-payment-amount="$store.state.order.draftPayments.bonuses.amount"
                  @update:bonuses-payment-amount="$store.dispatch('order/setBonusesAmount', $event)"
                  @update:saveCard="form.save_card = $event"
  />

  <PaymentSummary v-if="$store.state.order.order.id"
                  :payments-preview="$store.state.order.paymentsPreview"
                  :order-total-price="$store.state.order.order.id ? $store.state.order.order.total_price : null"
                  :order-original-total-price="$store.state.order.order.id ? $store.state.order.order.original_total_price : null"
                  :order-discount-difference="$store.state.order.order.id ? $store.state.order.order.discount_difference : null"
  />
  <LegalNotice v-if="!hasUser" class="order-submission__legal-notice"/>

  <TransitionExpand>
    <div v-if="submissionError" class="rounded-md bg-danger-lighter p-4 rounded">
      <div class="flex">
        <div class="flex-shrink-0">
          <svg class="h-5 w-5 text-danger-darker" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
          </svg>
        </div>
        <div class="ml-3">
          <h3 class="text-sm leading-5 font-medium text-danger-darker">
            {{ submissionError.title }}
          </h3>
          <div class="mt-2 text-sm leading-5 text-danger-darker">
            <ul class="list-disc pl-5">
              <li v-for="(errorText, index) in submissionError.errors" :class="{ 'mt-1': index > 0 }">
                {{ errorText }}
              </li>
            </ul>
            <p class="mt-2">
              Если ошибка повторяется, попробуйте
              <a href="javascript:;" class="text-danger-dark font-bold hover:underline" @click="truncateOrder">очистить корзину</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  </TransitionExpand>
</ValidationObserver>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import TransitionExpand from '@/components/AsyncTransitionExpand';
import CustomInput from '@/components/inputs/CustomInput';
import CustomField from '@/components/inputs/CustomField';
import PhoneInput from '@/components/inputs/PhoneInput';
import OtherInfoSection from './OtherInfoSection';
import PaymentSection from './PaymentSection';
import PaymentSummary from '../PaymentSummary.vue';
import LegalNotice from '@/components/legal/LegalNotice';
import { ValidationProvider, ValidationObserver } from '@/helpers/veeValidateCustomized';
import addressToString from '@/helpers/addressToString';
import storage from '@/storage'
import CartProductRewardCard from '@/components/cart/CartProductRewardCard'
import DadataAddressResolver from '@/components/addresses/dadata/DadataAddressResolver'
import PlainAddressResolver from '@/components/addresses/plain/PlainAddressResolver'

export default {
  components: {
    CartProductRewardCard,
    TransitionExpand,
    PhoneInput,
    CustomInput,
    CustomField,
    ValidationProvider,
    ValidationObserver,
    OtherInfoSection,
    PaymentSection,
    PaymentSummary,
    LegalNotice,
    DadataAddressResolver,
    PlainAddressResolver,
    IconArrowDown: () => import('@/assets/images/icons/icon-arrow-down-small.svg?inline'),
  },

  props: {
    submitOrderApiError: {
      required: false,
      type: Object,
      default: () => null,
    },
  },

  mounted() {
    this.loadOrderDeliveryMethods()
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      hasUser: 'auth/hasUser',
      authenticationEnabled: 'store/authenticationEnabled',
      totalPrice: 'order/totalPrice',
      activeCity: 'store/activeCity',
      stocks: 'store/visibleActiveCityStocks',
      orderId: 'order/orderId',
      maxBonusesPayment: 'order/maxBonusesPayment',
      rewardSelector: 'order/rewardSelector',
      addressesResolver: 'store/addressesResolver',
    }),

    ...mapState({
      order: state => state.order.order,
      authToken: state => state.auth.token,
    }),

    orderCustomer() {
      const customer = this.$store.state.order.order?.customer;

      if (!!customer && Object.keys(customer).length === 0) { // The backend returns an empty object instead of null
        return null;
      }

      return this.$store.state.order.order?.customer;
    },

    phoneAlreadyFilled() {
      if (!this.authenticationEnabled) {
        return false
      }

      return this.hasUser && !!this.user.phone
    },

    deliveryDeliveryMethod() {
      return this.deliveryMethods.find(method => method.id === 'delivery')
    },

    deliveryMethodAllowed() {
      return !!this.deliveryDeliveryMethod
    },

    pickupDeliveryMethod() {
      return this.deliveryMethods.find(method => method.id === 'pickup')
    },

    pickupMethodAllowed() {
      return !!this.pickupDeliveryMethod
    },

    onPremiseDeliveryMethod() {
      return this.deliveryMethods.find(method => method.id === 'on_premise')
    },

    onPremiseMethodAllowed() {
      return !!this.onPremiseDeliveryMethod
    },

    submitOrderApiData() {
      const payment = {
        method: this.form.payment_method,
        amount: this.form.expected_payment_amount?.toString(),
      };

      if (payment.method === 'card_token') {
        payment.card_token_id = this.form.card_token_id;
      } else if (payment.method === 'cloudpayments') {
        payment.save_card = this.form.save_card
      }

      const apiData = {
        delivery_method: this.form.delivery_method,
        stock_id: this.form.stock_id,
        payments: [payment],
      };

      if (typeof this.$store.state.order.order?.customer?.id !== 'string') {
        apiData.customer = {
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          phone: this.form.phone,
          phone_country: this.form.phone_country,
        };
      }

      if (this.form.delivery_method === 'delivery') {
        const selectedAddress = this.form.deliveryAddress.selectedSavedAddress;

        if (selectedAddress) {
          apiData.delivery_address = { id: selectedAddress.id };
        } else {
          apiData.delivery_address = this.form.deliveryAddress.newAddress
        }
      } else if (this.form.delivery_method === 'on_premise') {
        apiData.on_premise = {
          table: this.form.onPremise.table,
        }
      }

      let apiNotes = this.form.notes;
      if (Number.isSafeInteger(parseInt(this.form.num_people, 10))) {
        apiNotes += `\nПерсон: ${this.form.num_people}`;
      }
      apiData.notes = apiNotes;

      if (this.form.deliveryTime !== null) {
        apiData.deliver_at = this.form.deliveryTime;
      }

      if (this.$store.state.order.draftPayments.bonuses.amount > 0) {
        apiData.payments.push({
          method: 'bonuses',
          amount: this.$store.state.order.draftPayments.bonuses.amount,
        });
      }

      return apiData;
    },

    savedAddresses() {
      const storeAddresses = this.$store.state.savedAddresses.addresses;

      if (!Array.isArray(storeAddresses)) {
        return [];
      }

      return storeAddresses;
    },

    submissionError() {
      if (!this.submitOrderApiError) {
        return null
      }

      return {
        title: 'Произошла ошибка во время оформления заказа:',
        errors: [
          this.submissionErrorText,
        ],
      }
    },

    submissionErrorText() {
      if (!this.submitOrderApiError) {
        return ''
      }

      switch (this.submitOrderApiError.error_code) {
        case 'payments.amount_exceeds_limit':
          return 'вы указали слишком большую сумму бонусов для списания.'
      }

      if (this.submitOrderApiError.message !== this.submitOrderApiError.original_message) {
        return this.submitOrderApiError.message
      }

      return 'неизвестная ошибка'
    },
  },

  methods: {
    addressToString,

    ...mapActions({
      'savedAddresses/load': 'savedAddresses/load',
      loadDeliveryMethods: 'order/loadDeliveryMethods',
    }),

    async loadOrderDeliveryMethods() {
      try {
        this.deliveryMethods = await this.loadDeliveryMethods()
      } catch (e) {
        this.deliveryMethods = []
      }
    },

    stockHasAddress(stock) {
      return stock.addresses && stock.addresses.length !== 0
    },

    firstStockAddress(stock) {
      return stock.addresses[0].full
    },

    stockHasSchedule(stock) {
      return !!stock.schedule && !!stock.schedule.today
    },

    stockSchedule(stock) {
      if (!stock.schedule.today.open) {
        return `Откроется ${stock.schedule.today.next_open_at.short}`
      }

      return `Сегодня: ${stock.schedule.today.hours.join(', ')}`
    },

    truncateOrder() {
      if (!confirm('Вы уверены, что хотите очистить корзину?')) {
        return
      }

      storage.activeOrderId(null, true)
      storage.activeOrderToken(null, true)
      storage.deliveryMethod(null, true)

      location.reload()
    },

    getFreshOrderForm() {
      let deliveryMethod = storage.deliveryMethod()

      if (!deliveryMethod) {
        deliveryMethod = Array.isArray(this.deliveryMethods) ? this.deliveryMethods[0].id || 'delivery' : 'delivery'
      }

      return {
        first_name: '',
        last_name: '',
        phone: '',
        phone_country: '',
        delivery_method: deliveryMethod,
        payment_method: 'credit-card',
        card_token_id: '',
        save_card: false,
        expected_payment_amount: null,
        stock_id: '',
        notes: '',
        num_people: '',
        deliveryTime: null,
        deliveryAddress: {
          newAddress: null,
          selectedSavedAddress: null, // TODO no default value + required validation?
        },
        onPremise: {
          table: ''
        },
      }
    },
  },

  watch: {
    submitOrderApiData: {
      deep: true,
      // TODO perf: just run the getter once when it is needed, not on every change?
      handler: function (newVal) {
        this.$emit('updated', newVal);
      },
    },

    orderId(orderId) {
      if (!orderId) {
        return
      }

      this.$nextTick(() => {
        this.form = this.getFreshOrderForm();
      })
    },

    authToken: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this['savedAddresses/load'](newVal);
        }
      },
    },

    deliveryMethods: {
      immediate: true,
      handler() {
        if (!Array.isArray(this.deliveryMethods) || !this.deliveryMethods.length) {
          return
        } else if (this.deliveryMethods.map(method => method.id).indexOf(this.form.delivery_method) === -1) {
          this.form.delivery_method = this.deliveryMethods[0].id
        }
      },
    },

    stocks: {
      immediate: true,
      handler(val) {
        if (this.form.delivery_method === 'delivery') {
          return
        } else if (!Array.isArray(val) || !val.length) {
          return
        }

        this.form.stock_id = val[0].id
      }
    },

    ['form.delivery_method'](val) {
      if (val !== 'delivery' && !this.form.stock_id && Array.isArray(this.stocks) && this.stocks.length > 0) {
        this.form.stock_id = this.stocks[0].id
      }
    },
  },

  data() {
    return {
      formIsBusy: false,
      form: this.getFreshOrderForm(),
      collapseNewAddressDetailFields: true,
      collapseLastNameField: true,
      deliveryMethods: [],
    }
  }
}
</script>

<style lang="less">
@import "~flatpickr/dist/flatpickr.css";

.order-submission-form {
  @apply px-4;

  .form-card {
    @apply bg-white rounded my-4 px-4;
    padding-bottom: 1px;
    padding-top: 1px;
  }

  .fields-container {
    @apply flex flex-wrap my-3 -mx-1;
    > * {
      @apply m-1 flex-grow;
    }
  }

  .name-and-phone {
    .form-field {
      flex-basis: theme('width.48');
    }
  }

  .order-delivery-section {

    .order-delivery-tabbar {
      @apply flex -mx-4;
      margin-top: -1px;

      .order-delivery-tab {
        @apply flex-grow text-center text-grey p-4 border-b;

        input {
          @apply opacity-0 absolute; // Don't `display: none;` so accessibility is preserved.
        }

        &.active {
          @apply border-b-2 border-primary text-primary;
        }

        &:focus-within {}
      }
    }

    .order-delivery__expand-button {
      @apply px-2 h-8 border border-grey-light rounded flex items-center justify-center
        text-sm text-primary;
      box-sizing: content-box;
      svg {
        @apply stroke-current w-4;
        transition: transform 0.15s ease-out;
      }
      &[aria-expanded="true"] {
        svg {
          transform: rotate(180deg);
        }
      }
    }
    .order-delivery__expand-button-text {
      @apply px-2;
    }

    .order-delivery__address-fields {
      @apply my-3;
    }
    .address-fields-component__basic-info,
    .address-fields-component__detail-info {
      .fields-container();
      @apply my-0;
    }

    .order-delivery__expand-button-wrapper {
      @apply flex-grow-0;
    }

    .order-delivery__saved-address-select {
      @apply w-full my-3;
      .custom-radio {
        @apply flex text-sm;
      }
    }

    // Don't forget that they also have labels error messages and palceholders.
    .default-field(@min-width) {
      flex-basis: 0;
      min-width: @min-width;
      max-width: theme('width.48'); // In case there are just a few of them in one row.
    }
    .address-fields-component__city {
      flex-basis: 100%;
    }
    .address-fields-component__street {
      flex-basis: 100%;
    }
    .address-fields-component__house {
      .default-field(theme('width.20'));
      max-width: unset; // So when it always pushes the expand button to the right, even when the city fild is shown.
    }
    .address-fields-component__apt,
    .address-fields-component__entrance,
    .address-fields-component__floor,
    .order-delivery-num-people {
      .default-field(theme('width.20'));
    }
    .address-fields-component__intercom {
      .default-field(theme('width.32'));
    }
    .order-delivery-notes {
      flex-basis: 100%;
    }
    .order-delivery__time {
      .default-field(11rem);
      max-width: unset;
      .custom-field__field-wrapper {
        @apply relative;
        .order-delivery__time-asap-text {
          @apply absolute inset-y-0 left-0 flex items-center pointer-events-none
            pl-3 text-grey-darker text-sm; // Same as on inputs. DRY?
        }
        .order-delivery__time-asap-button {
          @apply absolute inset-y-0 right-0 w-8;
          .fa {
            @apply font-normal text-grey-darkest;
          }
        }
      }
      &--asap {
        .order-delivery__flatpickr-input {
          // `.order-delivery__time-asap-text` will replace it.
          @apply text-transparent;
          &::placeholder {
            @apply text-transparent;
          }
        }
      }
    }
  }

  .order-delivery__pickup-stocks {
    @apply my-3;
  }

  .order-submission-pickup-stock-label {
    .pickup-stock-title {
      @apply text-sm font-normal opacity-80;
    }
    .pickup-stock-address {
      @apply text-sm font-light opacity-60 block mt-2;
    }
    .pickup-stock-schedule {
      @apply text-sm font-light opacity-60 block mt-1;
    }
  }

  .order-submission-payment {
    // @apply px-4 rounded;

    .order-submission-payment__section {
      @apply my-4 py-4;
      .order-submission-payment__section-header {
        @apply mb-3 text-lg text-dark-darker font-normal;
      }
    }
    &__max-payment-text {
      @apply text-sm text-dark font-light;
      .order-submission-payment__max-payment-text-amount {
        @apply text-primary underline p-1;
        font-style: normal;
        text-decoration-style: dotted;
      }
    }

    .order-submission-payment__bonuses-section {
      @apply flex flex-wrap items-center;
      .order-submission-payment__section-header {
        flex-basis: 100%;
        &:last-child {
          @apply mb-0;
        }
      }
      .order-submission-payment__bonuses-amount-input {
        @apply w-32 mr-4;
      }
      // .order-submission-payment__button-confirm,
      // .order-submission-payment__button-cancel {
      //   @apply text-sm ml-2;
      // }
    }

    .order-submission-payment-options {
      @apply text-sm;
    }

    &__bills-input {
      @apply w-48 inline-block;
    }

    &__bills-section-label {
      @apply mt-4 mb-1;
    }
    &__input-and-suggestions {
      @apply -m-1;
      > * {
        @apply m-1;
      }
    }
    &__bills-suggestion {
      @apply inline-block border border-grey-light py-2 px-4 text-dark rounded text-sm;
      &:focus {
        @apply outline-none bg-light-dark;
      }
      &--active {
        @apply text-primary-dark bg-primary-lightest border-primary-light;
        &:focus {
          @apply bg-primary-lightest border-primary-dark;
        }
      }
    }
  }

  .order-submission__legal-notice {
    @apply text-xs font-light opacity-70 my-4;
    a {
      @apply text-primary;
    }
  }
}

@screen md {
  .order-submission-form {
    .order-delivery-section {
      .address-fields-component__city {
        flex-basis: 35%;
      }
      .address-fields-component__street {
        flex-basis: 55%;
      }
    }
  }
}
</style>
